<template>
  <!-- 待办任务 -->
  <div style="position: relative">
    <el-form ref="formMyTask" :model="formMyTask" label-width="100px" :size="defaultFormItemSize" label-position="right"
      @submit.native.prevent>
      <filter-box :item-width="350">
        <el-form-item label="申请单号" prop="formFilter.processDefinitionName">
          <el-input class="filter-item" v-model="formMyTask.formFilter.processDefinitionName" :clearable="true"
            placeholder="申请单号" />
        </el-form-item>

        <el-form-item label="发起时间" prop="formFilter.createDate">
          <date-range class="filter-item" v-model="formMyTask.formFilter.createDate" :clearable="true"
            :allowTypes="['day']" align="left" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <!--<el-form-item label="流程标识" prop="formFilter.processDefinitionKey">-->
        <!--<el-input-->
        <!--class="filter-item"-->
        <!--v-model="formMyTask.formFilter.processDefinitionKey"-->
        <!--:clearable="true"-->
        <!--placeholder="流程标识"-->
        <!--/>-->
        <!--</el-form-item>-->
        <el-form-item label="当前任务" prop="formFilter.taskName">
          <el-input class="filter-item" v-model="formMyTask.formFilter.taskName" :clearable="true" placeholder="当前任务" />
        </el-form-item>
        <el-form-item label="当前责任人" prop="formFilter.taskAssignee">
          <el-input class="filter-item" v-model="formMyTask.formFilter.taskAssignee" :clearable="true"
            placeholder="当前责任人" />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize"
          @click="onReset">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize"
          @click="refreshMyTask(true)">查询</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="onExport()">
          导出
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ background: '#FAFAFA', color: '#606266' }" ref="flowEntry"
          :data="formMyTask.taskWidget.dataList" :size="defaultFormItemSize"
          @sort-change="formMyTask.taskWidget.onSortChange" header-cell-class-name="table-header-gray">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
            :index="formMyTask.taskWidget.getTableIndex" />
          <el-table-column label="流程名称" prop="processDefinitionName" />
          <el-table-column label="申请单号" prop="processInstanceName" />
          <el-table-column label="当前任务" prop="taskName" />
          <el-table-column label="当前处理人" prop="taskAssignee" />
          <el-table-column label="任务发起人" prop="processInstanceInitiatorName" />
          <el-table-column label="任务发起时间" prop="processInstanceStartTime" />
          <el-table-column label="计划完成时间" prop="processInstanceDueTime" />

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button class="table-btn primary" :size="defaultFormItemSize" type="text"
                @click="onTransferTo(scope.row)">转办</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px">
          <el-pagination :total="formMyTask.taskWidget.totalCount" :current-page="formMyTask.taskWidget.currentPage"
            :page-size="formMyTask.taskWidget.pageSize" :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes" @current-change="formMyTask.taskWidget.onCurrentPageChange"
            @size-change="formMyTask.taskWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import "@/staticDict/flowStaticDict.js";
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget } from "@/utils/widget.js";
/* eslint-disable-next-line */
import {
  uploadMixin,
  statsDateRangeMixin,
  cachePageMixin,
} from "@/core/mixins";
/* eslint-disable-next-line */
import {
  FlowDictionaryController,
  FlowOperationController,
} from "@/api/flowController.js";
import TaskTransferTo from '@/views/workflow/components/TaskTransferTo.vue';
export default {
  name: "formMyTask",
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data() {
    return {
      paramsE: {},
      formMyTask: {
        formFilter: {
          processDefinitionName: undefined,
          processDefinitionKey: undefined,
          taskName: undefined,
          createDate: [],
          taskAssignee: undefined,
        },
        formFilterCopy: {
          processDefinitionName: undefined,
          processDefinitionKey: undefined,
          taskName: undefined,
          createDate: [],
          taskAssignee: undefined,
        },
        taskWidget: new TableWidget(
          this.loadTaskData,
          this.loadTaskDataVerify,
          true,
          false,
          "entryId",
          1
        ),
        isInit: false,
      },
    };
  },
  methods: {
    onReset() {
      this.$refs.formMyTask.resetFields();
      this.refreshMyTask(true);
    },
    loadTaskData(params) {
      if (params == null) params = {};
      var searchAssignee = 'all';
      if (this.formMyTask.formFilterCopy.taskAssignee) {
        searchAssignee = this.formMyTask.formFilterCopy.taskAssignee;
      }
      params = {
        search: searchAssignee,
        processDefinitionName:
          this.formMyTask.formFilterCopy.processDefinitionName,
        processDefinitionKey:
          this.formMyTask.formFilterCopy.processDefinitionKey,
        taskName: this.formMyTask.formFilterCopy.taskName,
        beginDate: this.formMyTask.formFilterCopy.createDate[0],
        endDate: this.formMyTask.formFilterCopy.createDate[1],
        ...params,
      };
      this.paramsE = params;
      return new Promise((resolve, reject) => {
        FlowOperationController.listRuntimeTask(this, params)
          .then((res) => {
            resolve({
              dataList: res.data.dataList,
              totalCount: res.data.totalCount,
            });
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    onSelectAssignee(row) {
      this.$dialog.show('选择用户', TaskTransferTo, {
        area: ['450px', '280px']
      }).then(res => {
        var params = {};
        params['processInstanceId'] = row['processInstanceId'];
        params['taskId'] = row['taskId'];
        params['comment'] = res['message'];
        params['delegateAssignee'] = res['assignee'];
        console.log(res);
        FlowOperationController.interveneRuntimeTask(this, params).then(res => {
          if (res.success) {
            this.$message.success('操作成功！');
            this.refreshMyTask();
          }
        }).catch(e => { });
      }).catch(e => { });
    },
    onTransferTo(row) {
      //转办
      this.onSelectAssignee(row);
    },
    loadTaskDataVerify() {
      this.formMyTask.formFilterCopy.taskAssignee = this.formMyTask.formFilter.taskAssignee;
      this.formMyTask.formFilterCopy.processDefinitionName =
        this.formMyTask.formFilter.processDefinitionName;
      this.formMyTask.formFilterCopy.processDefinitionKey =
        this.formMyTask.formFilter.processDefinitionKey;
      this.formMyTask.formFilterCopy.taskName =
        this.formMyTask.formFilter.taskName;
      this.formMyTask.formFilterCopy.createDate = Array.isArray(this.formMyTask.formFilter.createDate) ? [...this.formMyTask.formFilter.createDate] : [];
      return true;
    },
    refreshMyTask(reloadData = false) {
      if (reloadData) {
        this.formMyTask.taskWidget.refreshTable(true, 1);
      } else {
        this.formMyTask.taskWidget.refreshTable();
      }
    },
    onExport() {
      this.$confirm("是否导出表格数据？").then((res1) => {
        var params = this.paramsE;
        let httpCall;
        httpCall = this.download(
          "/admin/flow/flowOperation/listHistoricTask/export/",
          params, "待办任务.xls"
        );
        httpCall
          .then((res) => {
            this.$message.success("导出成功！");
          })
          .catch((e) => {
            this.$message.error(e);
          });
      });
    },
    onResume() {
      this.refreshMyTask();
    },
    formInit() {
      this.refreshMyTask();
    },
  },
  mounted() {
    // 初始化页面数据
    this.formInit();
  },
};
</script>

<style></style>
